import {resetCustomerData, updateCurrentModalPage, updateShowModalFlag, updateSpecialEvent} from '../../redux/app-state-slice';
import loadCustomerDataFromInput from '../LoadCustomerDataFromInput';
import {trackEvents} from '../../Services/OptimizelyService/OptimizelyService';

export function CreatePrequalModalCloseEvent(detailInfo) {
  return new CustomEvent('prequalModalCloseEvent', {
    detail: detailInfo !== null ? detailInfo : {},
    bubbles: true,
    cancelable: true,
    composed: false
  });
}
export function CreatePrequalAppSubmissionEvent(customerData) {
  return new CustomEvent('prequalSubmissionResultEvent', {
    detail: {
      firstName: customerData.firstName.value,
      lastName: customerData.lastName.value,
      status: customerData.result?.value?.decisionCode,
      prequalifiedAmount: customerData.result?.value?.totalApprovedAmount,
      expirationDate: customerData.result?.value?.expirationDate,
      streetAddress: customerData.streetAddress.value,
      apartment: customerData.apartment.value,
      city: customerData.city.value,
      stateOrProvince: customerData.stateOrProvince.value,
      postalCode: customerData.postalCode.value
    }
  });
}

export function listenTier3ModalEventOpen(dispatch, customerData) {
  window.addEventListener('prequalModalOpenEvent', (e) => {
    const {prequalSource, prequalInput} = e.detail;
    if (!prequalSource.includes('ECOM')) {
      dispatch(updateCurrentModalPage(''));
    }
    dispatch(updateShowModalFlag(true));
    loadCustomerDataFromInput(prequalSource, prequalInput, customerData, dispatch);
  });
}

export function closeTier3ModalEvent(detailInfo, dispatch, customerData) {
  dispatch(updateShowModalFlag(false));
  const closeEvent = CreatePrequalModalCloseEvent(detailInfo);
  window.dispatchEvent(closeEvent);
  if (customerData?.result?.value?.decisionCode !== undefined) {
    const submitEvent = CreatePrequalAppSubmissionEvent(customerData);
    window.dispatchEvent(submitEvent);
  }
  dispatch(resetCustomerData(customerData));
}
export function closeModal(dispatch, customerData) {
  if (customerData?.recaptchaOptimizelyData?.isEnabled) {
    trackEvents('pq_review_bounce', customerData);
  }
  const specialEvent = customerData.specialEvent.value;
  dispatch(resetCustomerData());
  dispatch(updateShowModalFlag(false));
  dispatch(updateSpecialEvent(specialEvent));
}
